import { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Form, InputGroup, Nav, NavItem, Row, Tab } from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import { customFormatDate, formatDate, formatDateTime, getTimeAgo } from "../../../../../Components/DateFn";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import OpenActivitiesView from "../OpenActivitiesView";
import ClosedActivitiesView from "../ClosedActivitiesView";
import Select from "react-select";
import { Helpers } from "../../../../../Helpers";
import { Utils } from "../../../../../Utils";
import PermissionDeniedModal from "../../../../../Components/PermissionDeniedModal";
import ConfirmationModal from "../../../../../Components/ModalPopup/ConfirmationModal";
import EmailComposer from "../../../../../Components/EmailComposer";
import { getSubFormKanbanListStart, removeSubFormByIdStart, resetDeleteStatus, resetStateModule, updateSubFormByIdStart } from "../../../../../Store/Slices/subFormSlice";
import Loader from "../../../../../Components/Loader";
import { Check, Clock3, Pencil, X } from "lucide-react";
import { getDealLogStart, getDealActivitiesStart } from "../../../../../Store/Slices/dealSlice";

const DealDetails = ({ card, id, subFormData, basicPermissionData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let currentCurrencyData = useSelector((state) => state?.currency)?.data?.[0];
    let dealsLog = useSelector((state) => state.deal);
    let users = useSelector((state) => state?.user);
    const dealActivities = useSelector((state) => state?.deal)?.dealActivitiesData;
    const formsubmodules = useSelector((state) => state?.subForm);
    let defaultStages = subFormData?.modules?.stageProbability;
    const [cardData, setCardData] = useState(card || {});
    const [updateCardStatus, setUpdateCardStatus] = useState(false);
    const [key, setKey] = useState('Qualification');
    let [stageName, setStageName] = useState('');
    const [openDropdown, setOpenDropdown] = useState(null);

    const [hoverDealInfo, setHoverDealInfo] = useState(true);
    const [isEditDealInfo, setIsEditDealInfo] = useState(false);

    let [sendEmail, setSendEmail] = useState(false);
    let [permissionDenied, setPermissionDenied] = useState(false);
    let [removeModalData, setRemoveModalData] = useState(null);
    let [optionsList, setOptionsList] = useState([]);
    let [accountsList, setAccountsList] = useState([]);
    let [contactsList, setContactsList] = useState([]);

    let stageHistoryTableHeaders = ['Stage', 'Amount', 'Probability (%)', 'Expected Revenue', 'Closing Date', 'Modified Time'];

    useEffect(() => {
        if (formsubmodules?.kanbanData?.formsubmodules?.length > 0) {
            let updatedCard = formsubmodules?.kanbanData?.formsubmodules?.find(item => item._id === cardData?._id);
            const mergedObject = updatedCard?.data?.reduce((acc, curr) => {
                return { ...acc, ...curr.section_data };
            }, {});
            if (mergedObject) {
                mergedObject['createdAt'] = updatedCard?.createdAt;
                mergedObject['updatedAt'] = updatedCard?.updatedAt;
                mergedObject['createdBy'] = updatedCard?.userId;
                mergedObject['updatedBy'] = updatedCard?.updatedBy;
                mergedObject['userId'] = updatedCard?.userId;
                mergedObject['_id'] = updatedCard?._id;
                mergedObject['status'] = updatedCard?.status;
                setCardData(mergedObject);
            }
        }
    }, [formsubmodules?.kanbanData?.formsubmodules]);

    useEffect(() => {
        if (subFormData?.lookupData["Account Name"]?.length > 0) {
            let list = subFormData?.lookupData["Account Name"];
            let data = [];
            for (let x of list) {
                if (x?.data?.length > 0) {
                    for (let y of x?.data) {
                        let title = "Account Name";
                        let possibleKeys = [Helpers.replaceData(title), Helpers.replaceData(title + "_")];
                        for (let key of possibleKeys) {
                            let val = y?.section_data?.[key] || null;
                            if (y?.section_data?.hasOwnProperty(key) && !Array.isArray(val) && val) {
                                data.push({ _id: x?._id, name: (typeof val === "string" ? val : (val?.name || "")) });
                                break;
                            }
                        }
                    }
                }
            }
            setAccountsList(data);
        }

        if (subFormData?.lookupData["Contact Name"]?.length > 0) {
            let list = subFormData?.lookupData["Contact Name"];
            let data = [];
            for (let x of list) {
                if (x?.data?.length > 0) {
                    for (let y of x?.data) {
                        let title = "Contact Owner";
                        let possibleKeys = [Helpers.replaceData(title), Helpers.replaceData(title + "_")];
                        for (let key of possibleKeys) {
                            let val = y?.section_data?.[key] || null;
                            if (y?.section_data?.hasOwnProperty(key) && !Array.isArray(val) && val) {
                                data.push({ _id: x?._id, name: (typeof val === "string" ? val : (val?.name || "")) });
                                break;
                            }
                        }
                    }
                }
            }
            setContactsList(data);
        }
    }, [subFormData?.lookupData])

    useEffect(() => {
        if (users?.allUserData?.length > 0) {
            setOptionsList(users?.allUserData?.map(x => (x?._id?.length > 0 ? {
                _id: x?._id,
                name: `${x?.firstName || ''} ${x?.lastName || ''}`,
                profilePicture: x?.profilePicture,
                email: x?.email
            } : x)));
        } else {
            setOptionsList([])
        }
    }, [users?.allUserData])

    useEffect(() => {
        if (cardData?.Stage) {
            setStageName(defaultStages.find(stage => stage.id === Number(cardData?.Stage))?.stageName || '');
            setKey(defaultStages.find(stage => stage.id === Number(cardData?.Stage))?.stageName || 'Qualification');
        }
    }, [cardData?.Stage]);

    useEffect(() => {
        if (cardData?._id) {
            dispatch(getDealLogStart(cardData?._id));
            dispatch(getDealActivitiesStart(cardData?._id));
            dispatch(getSubFormKanbanListStart({ id }));
        }
    }, []);

    useEffect(() => {
        if (formsubmodules?.updateStatus && id) {
            setUpdateCardStatus(true);
            if (id) dispatch(getSubFormKanbanListStart({ id }));
            if (cardData?._id) dispatch(getDealLogStart(cardData?._id));
        }
    }, [formsubmodules?.updateStatus]);

    useEffect(() => {
        if (updateCardStatus && formsubmodules?.kanbanData?.formsubmodules?.length > 0) {
            let updatedCard = formsubmodules?.kanbanData?.formsubmodules?.find(item => item._id === cardData?._id);
            const mergedObject = updatedCard?.data?.reduce((acc, curr) => {
                return { ...acc, ...curr.section_data };
            }, {});
            if (mergedObject) {
                mergedObject['createdAt'] = updatedCard?.createdAt;
                mergedObject['updatedAt'] = updatedCard?.updatedAt;
                mergedObject['createdBy'] = updatedCard?.userId;
                mergedObject['updatedBy'] = updatedCard?.updatedBy;
                mergedObject['userId'] = updatedCard?.userId;
                mergedObject['_id'] = updatedCard?._id;
                mergedObject['status'] = updatedCard?.status;
                setCardData(mergedObject);
            }
        }
    }, [formsubmodules?.kanbanData?.formsubmodules]);

    useEffect(() => {
        if (formsubmodules?.deleteStatus === true) {
            dispatch(resetDeleteStatus());
            navigate(-1);
        }
    }, [formsubmodules?.deleteStatus])

    const getCurrency = (amt) => {
        return parseFloat(amt.replace(/,/g, '')).toFixed(2)
    }

    const handleUpdateStage = (stage) => {
        let stage_id = defaultStages.find(stg => stg?.stageName === stage)?.id
        if (stage_id && String(stage_id) !== cardData?.Stage && cardData?._id && id && subFormData?.kanbanData?.formsubmodules?.length > 0) {
            let isSubFormData = subFormData?.kanbanData?.formsubmodules?.find((item) => item._id === cardData?._id)?.data
            let updateKeys = {
                formsubmodules: "formsubmodules",
                message: "message",
                exit: "exit",
                isLoading: "isLoading",
                status: "status",
                reload: "reload",
                error: "error"
            }

            let sections = isSubFormData?.map(section =>
                section.section_name === "Deal Information"
                    ? {
                        ...section,
                        section_data: {
                            ...section.section_data,
                            Stage: String(defaultStages?.find(x => x?.stageName === stage)?.id),
                            Probability_: defaultStages?.find(x => x?.stageName === stage)?.probability,
                            Expected_Revenue: getCurrency(cardData?.Amount) * (defaultStages?.find(x => x?.stageName === stage)?.probability / 100)
                        }
                    }
                    : section
            );

            const dealInfo = sections?.find(s => s?.section_name === "Deal Information");
            const dealOwnerId = dealInfo?.section_data?.Deal_Owner?._id;

            const mergedObject = sections.reduce((acc, curr) => {
                return { ...acc, ...curr.section_data };
            }, {});

            let payload = {
                audit_log: { msg: '' },
                data: sections,
                moduleId: id,
                userId: dealOwnerId,
                stage_history: mergedObject
            }

            dispatch(updateSubFormByIdStart({
                subModuleId: cardData?._id,
                payload: payload,
                updateKeys
            }));
        }
    }

    const handleUpdateDealData = () => {
        if (cardData?._id && id && subFormData?.formsubmodules?.length > 0) {
            let isSubFormData = subFormData?.formsubmodules?.find((item) => item._id === cardData?._id)?.data
            let updateKeys = {
                formsubmodules: "formsubmodules",
                message: "message",
                exit: "exit",
                isLoading: "isLoading",
                status: "status",
                reload: "reload",
                error: "error"
            }

            const updatedSections = isSubFormData.map((section) => {
                const updatedSectionData = { ...section.section_data };

                Object.keys(section.section_data).forEach((key) => {
                    if (cardData.hasOwnProperty(key)) {
                        updatedSectionData[key] = cardData[key];
                    }
                });

                return {
                    ...section,
                    section_data: updatedSectionData,
                };
            });

            const dealInfo = updatedSections?.find(s => s?.section_name === "Deal Information");
            const dealOwnerId = dealInfo?.section_data?.Deal_Owner?._id;

            let payload = {
                audit_log: { msg: '' },
                data: updatedSections,
                moduleId: id,
                userId: dealOwnerId,
            }

            dispatch(updateSubFormByIdStart({
                subModuleId: cardData?._id,
                payload: payload,
                updateKeys
            }));
        }
    }

    const removeData = (subModuleId) => {
        dispatch(removeSubFormByIdStart(subModuleId));
    }

    const handleChange = (e) => {
        try {
            const { name, value } = e.target;
            if (name === 'Stage') {
                setStageName(value);
                setCardData((prev) => ({
                    ...prev,
                    Stage: String(defaultStages?.find(x => x?.stageName === value)?.id),
                    Probability_: defaultStages?.find(x => x?.stageName === value)?.probability,
                    Expected_Revenue: getCurrency(cardData?.Amount) * (defaultStages?.find(x => x?.stageName === value)?.probability / 100)
                }));
            } else if (name === 'Amount') {
                setCardData((prev) => ({
                    ...prev,
                    [name]: value,
                    Expected_Revenue: getCurrency(value) * (defaultStages?.find(x => x?.stageName === stageName)?.probability / 100)
                }));
            } else {
                setCardData((prev) => ({
                    ...prev,
                    [name]: value
                }));
            }
        } catch (err) {
            throw err;
        }
    }

    const handleChangeDealOwner = (e) => {
        try {
            setCardData((prev) => ({
                ...prev,
                Deal_Owner: { _id: e?._id, name: e?.name }
            }));
        } catch (err) {
            throw err;
        }
    }

    const handleChangeLookup = (e, field) => {
        try {
            setCardData((prev) => ({
                ...prev,
                [field]: e
            }));
        } catch (err) {
            throw err;
        }
    }

    const handleSave = () => {
        setIsEditDealInfo(false);
        setHoverDealInfo(true);
        handleUpdateDealData();
    }

    let CustomOption = ({ data, innerRef, innerProps }) => (
        data.email ?
            <>
                <div ref={innerRef} {...innerProps} className="d-flex align-items-center p-2">
                    <img
                        src={data.profilePicture}
                        alt={data.name}
                        className="rounded-circle me-2"
                        style={{ width: '30px', height: '30px' }}
                    />
                    <div>
                        <div>{data.name}</div>
                        <small className="text-muted">{data.email}</small>
                    </div>
                </div>
            </> :
            <>
                <div ref={innerRef} {...innerProps} className="d-flex align-items-center p-2">
                    <span>{data.name}</span>
                </div>
            </>
    );

    let customStyles = {
        multiValue: (provided) => ({
            ...provided,
            borderRadius: "5px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999
        })
    };

    return (
        <>
            <Loader isVisible={formsubmodules?.isLoading} />
            <div className="container-fluid">
                <Card className="py-2">
                    <Row>
                        <div className="col-6 d-inline-flex align-items-center">
                            <div className="me-3">
                                <i className="fa fa-arrow-left me-2 cursor-pointer" onClick={() => navigate(-1)}></i>
                            </div>
                            <div> <span className="fw-semibold">{cardData?.Deal_Name || "Deal Name"}</span> - {currentCurrencyData?.currency_code} {cardData?.Amount}</div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center">
                            <Button variant='primary'
                                className="me-2"
                                onClick={() => {
                                    setSendEmail(true);
                                }}
                            >Send Mail</Button>
                            <Dropdown>
                                <Dropdown.Toggle variant="light border pe-2 with-arrow">
                                    <span className='pe-4'>Actions</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="shadow-sm rounded-2">
                                    <Dropdown.Item
                                        onClick={() => {
                                            dispatch(resetStateModule());
                                            navigate(
                                                Utils.getNavigationUrl(`form-module/sub-form/update/${id}/${cardData?._id}`)
                                            );
                                        }}
                                    >Edit</Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() =>
                                            !basicPermissionData?.some(
                                                (x) => x?.id === id && x.activities.delete === true
                                            )
                                                ? setPermissionDenied(true)
                                                : cardData?._id
                                                    ? setRemoveModalData({
                                                        subModuleId: cardData?._id,
                                                        payload: {
                                                            _id: cardData?._id,
                                                            moduleId: id
                                                        }
                                                    })
                                                    : console.error('rowId is undefined')
                                        }
                                    >Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Row>
                </Card>
                <div className="hstack justify-content-between my-2">
                    <h5 className="mb-0">Overview</h5>
                    <div className="justify-content-end hstack gap-2">
                        <Clock3 height={15} width={15} />
                        Last update : {getTimeAgo(cardData?.updatedAt)}
                    </div>
                </div>

                <Tab.Container id="pill-tab" defaultActiveKey={key}>
                    <Card className="p-2">
                        <Row>
                            <div className="col-6 text-start">
                                <span className="fw-semibold">START</span>
                                <span className="d-block fs-12">{formatDate(cardData?.createdAt)}</span>
                            </div>
                            <div className="col-6 text-end">
                                <span className="fw-semibold">CLOSING</span>
                                <span className="d-block fs-12 fw-500">{formatDate(cardData?.Closing_Date)}</span>
                            </div>
                        </Row>
                        <div
                            style={{
                                whiteSpace: 'nowrap',
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#ccc transparent',
                            }}
                            className="d-flex overflow-x-auto custom-scroll"
                        >
                            <Nav className='gap-2 mt-2 flex-nowrap d-inline-flex'
                                variant="pills"
                                onSelect={(k) => setKey(k)}>
                                {defaultStages?.map((stage, index) => (
                                    <Dropdown as={NavItem} key={index}
                                        show={openDropdown === stage?.stageName}
                                        onToggle={() => { }}
                                    >
                                        <div className={`d-inline-flex align-items-center`}>
                                            <Button
                                                variant={key === stage?.stageName ? 'primary bg-primary-subtle text-primary' : 'light border-secondary'}
                                                onClick={() => {
                                                    setKey(stage?.stageName);
                                                    setOpenDropdown(null);
                                                    handleUpdateStage(stage?.stageName);
                                                }}
                                                className={`px-3 py-1 rounded-4`}
                                                style={{ outline: "none",}}
                                            >
                                                {stage?.stageName}
                                            </Button>
                                        </div>
                                    </Dropdown>
                                ))}
                            </Nav>
                        </div>
                    </Card>
                    <Tab.Content>
                        <Tab.Pane eventKey="Qualification">
                            <Card body className="p-0 mt-2">
                                <Form.Group as={Row}
                                    className="mb-1 align-items-center position-relative"
                                    controlId="dealOwner"
                                >
                                    <Form.Label column sm="2" className="label-color">
                                        Deal Owner
                                    </Form.Label>
                                    <Col sm="4" className="position-relative">
                                        <div className="d-flex align-items-center position-relative">
                                            <Form.Control plaintext={true} readOnly={true} value={cardData?.Deal_Owner?.name} />
                                        </div>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1" controlId="probability">
                                    <Form.Label column sm="2" className="label-color">
                                        Probability (%)
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control plaintext={true} readOnly={true} value={cardData?.Probability_} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1" controlId="expectedRevenue">
                                    <Form.Label column sm="2" className="label-color">
                                        Expected Revenue
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control plaintext={true} readOnly={true} value={currentCurrencyData?.currency_code + ' ' + cardData?.Expected_Revenue} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1" controlId="closingDate">
                                    <Form.Label column sm="2" className="label-color">
                                        Closing Date
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control plaintext={true} readOnly={true} value={formatDate(cardData?.Closing_Date)} />
                                    </Col>
                                </Form.Group>
                            </Card>
                            <Card body className="p-0 mt-2">
                                <Card.Title as={'h6'} className="fw-medium pb-3"
                                    onMouseEnter={() => setHoverDealInfo(true)}
                                    onMouseLeave={() => setHoverDealInfo(true)}
                                >Deal Information
                                    {hoverDealInfo && !isEditDealInfo && (
                                        <Pencil
                                            className="icon-btn icon-edit-deal"
                                            size={18}
                                            onClick={() => { setIsEditDealInfo(true); }}
                                        />
                                    )}
                                    {isEditDealInfo && (
                                        <div className="d-flex align-items-center icon-group">
                                            <Check className="icon-btn icon-save-deal" size={18} style={{ marginRight: '30px' }} onClick={() => handleSave()} />
                                            <X className="icon-btn icon-cancel-deal" size={18} onClick={() => { setCardData(card); setHoverDealInfo(true); setIsEditDealInfo(false); }} />
                                        </div>
                                    )}
                                </Card.Title>
                                <Row>
                                    <div className="col-6">
                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="infoDealOwner"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Deal Owner
                                            </Form.Label>
                                            <Col sm="8" className="position-relative">
                                                <div className="d-flex align-items-center position-relative">
                                                    {!isEditDealInfo ?
                                                        <Form.Control plaintext readOnly value={cardData?.Deal_Owner?.name} className="no-focus-border" />
                                                        : <div className={`form-control multi-select border-0 p-0`}>
                                                            <Select
                                                                options={optionsList}
                                                                isMulti={false}
                                                                value={cardData?.Deal_Owner}
                                                                name="Deal_Owner"
                                                                onChange={(e) => handleChangeDealOwner(e)}
                                                                placeholder="Select Options"
                                                                getOptionLabel={(option) => option.name}
                                                                getOptionValue={(option) => (option?._id?.length > 0 ? option?._id : option.name)}
                                                                components={{ Option: CustomOption }}
                                                                styles={customStyles}
                                                                className="multiSelectContainer"
                                                                classNamePrefix="select"
                                                                closeMenuOnSelect={true}
                                                                menuPosition={"fixed"}
                                                                // menuIsOpen
                                                                menuPortalTarget={document.getElementById('root')}
                                                                isClearable={true}
                                                                classNames={{
                                                                    menuPortal: (state) => 'react-select-portal',
                                                                }}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="infoDealName"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Deal Name
                                            </Form.Label>
                                            <Col sm="8">
                                                <div className="d-flex align-items-center position-relative">
                                                    <Form.Control
                                                        plaintext={!isEditDealInfo}
                                                        readOnly={!isEditDealInfo}
                                                        value={cardData?.Deal_Name}
                                                        name="Deal_Name"
                                                        onChange={(e) => handleChange(e)}
                                                        className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                    />
                                                </div>
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="infoAccountName"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Account Name
                                            </Form.Label>
                                            <Col sm="8" className="position-relative">
                                                <div className="d-flex align-items-center position-relative">
                                                    {!isEditDealInfo ?
                                                        <Form.Control plaintext readOnly value={cardData?.Account_Name?.name} className="no-focus-border" />
                                                        : <div className={`form-control multi-select border-0 p-0`}>
                                                            <Select
                                                                options={accountsList}
                                                                isMulti={false}
                                                                value={cardData?.Account_Name}
                                                                name="Account_Name"
                                                                onChange={(e) => handleChangeLookup(e, 'Account_Name')}
                                                                placeholder="Select Options"
                                                                getOptionLabel={(option) => option.name}
                                                                getOptionValue={(option) => (option?._id?.length > 0 ? option?._id : option.name)}
                                                                components={{ Option: CustomOption }}
                                                                styles={customStyles}
                                                                className="multiSelectContainer"
                                                                classNamePrefix="select"
                                                                closeMenuOnSelect={true}
                                                                menuPosition={"fixed"}
                                                                // menuIsOpen
                                                                menuPortalTarget={document.getElementById('root')}
                                                                isClearable={true}
                                                                classNames={{
                                                                    menuPortal: (state) => 'react-select-portal',
                                                                }}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="infoType">
                                            <Form.Label column sm="4" className="label-color">
                                                Type
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control plaintext readOnly value={cardData?.Type} className="no-focus-border" />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="infoLeadSource">
                                            <Form.Label column sm="4" className="label-color">
                                                Lead Source
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control plaintext readOnly value={cardData?.Lead_Source} className="no-focus-border" />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="infoContactName"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Contact Name
                                            </Form.Label>
                                            <Col sm="8" className="position-relative">
                                                <div className="d-flex align-items-center position-relative">
                                                    {!isEditDealInfo ?
                                                        <Form.Control plaintext readOnly value={cardData?.Contact_Name?.name} className="no-focus-border" />
                                                        : <div className={`form-control multi-select border-0 p-0`}>
                                                            <Select
                                                                options={contactsList}
                                                                isMulti={false}
                                                                value={cardData?.Contact_Name}
                                                                name="Contact_Name"
                                                                onChange={(e) => handleChangeLookup(e, 'Contact_Name')}
                                                                placeholder="Select Options"
                                                                getOptionLabel={(option) => option.name}
                                                                getOptionValue={(option) => (option?._id?.length > 0 ? option?._id : option.name)}
                                                                components={{ Option: CustomOption }}
                                                                styles={customStyles}
                                                                className="multiSelectContainer"
                                                                classNamePrefix="select"
                                                                closeMenuOnSelect={true}
                                                                menuPosition={"fixed"}
                                                                // menuIsOpen
                                                                menuPortalTarget={document.getElementById('root')}
                                                                isClearable={true}
                                                                classNames={{
                                                                    menuPortal: (state) => 'react-select-portal',
                                                                }}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </Col>
                                        </Form.Group>
                                        <Row className="mb-1">
                                            <Col sm="4" className="label-color form-label col-form-label">
                                                Modified By
                                            </Col>
                                            <Col sm="8">
                                                {cardData?.updatedBy?.firstName && <div style={{ fontWeight: 500 }}>{cardData?.updatedBy?.firstName + ' ' + cardData?.updatedBy?.lastName || ''}</div>}
                                                <div>{customFormatDate(cardData?.updatedAt)}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group as={Row} className="mb-1" controlId="infoAmount">
                                            <Form.Label column sm="4" className="label-color">
                                                Amount
                                            </Form.Label>
                                            <Col sm="8">
                                                {!isEditDealInfo ?
                                                    <Form.Control plaintext={true} readOnly={true} value={currentCurrencyData?.currency_code + ' ' + cardData?.Amount} className="no-focus-border" />
                                                    : <InputGroup>
                                                        <InputGroup.Text id="basic-addon1">{currentCurrencyData?.currency_code}</InputGroup.Text>
                                                        <Form.Control
                                                            value={cardData?.Amount}
                                                            name="Amount"
                                                            onChange={(e) => handleChange(e)}
                                                        />
                                                    </InputGroup>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="infoClosingDate">
                                            <Form.Label column sm="4" className="label-color">
                                                Closing Date
                                            </Form.Label>
                                            <Col sm="8">
                                                {!isEditDealInfo ?
                                                    <Form.Control plaintext={true} readOnly={true} value={formatDate(cardData?.Closing_Date)} className="no-focus-border" />
                                                    : <Form.Control
                                                        type="date"
                                                        value={cardData?.Closing_Date}
                                                        name="Closing_Date"
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="infoStage">
                                            <Form.Label column sm="4" className="label-color">
                                                Stage
                                            </Form.Label>
                                            <Col sm="8">
                                                {!isEditDealInfo ?
                                                    <Form.Control plaintext readOnly value={stageName} className="no-focus-border" />
                                                    : <Form.Select
                                                        value={stageName}
                                                        name="Stage"
                                                        onChange={(e) => handleChange(e)}
                                                    >
                                                        <option value="">Select Stage</option>
                                                        {defaultStages?.map((stage, index) => (
                                                            <option key={index} value={stage?.stageName}>{stage?.stageName}</option>
                                                        ))}
                                                    </Form.Select>
                                                }
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="infoProbability">
                                            <Form.Label column sm="4" className="label-color">
                                                Probability (%)
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control plaintext readOnly value={cardData?.Probability_} className="no-focus-border" />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="infoExpectedRevenue">
                                            <Form.Label column sm="4" className="label-color">
                                                Expected Revenue
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control plaintext readOnly value={currentCurrencyData?.currency_code + ' ' + cardData?.Expected_Revenue} className="no-focus-border" />
                                            </Col>
                                        </Form.Group>
                                        <Row className="mb-1" controlId="infoCreatedBy">
                                            <Col sm="4" className="label-color form-label col-form-label">
                                                Created By
                                            </Col>
                                            <Col sm="8">
                                                <div style={{ fontWeight: 500 }}>{cardData?.createdBy?.firstName + ' ' + cardData?.createdBy?.lastName || ''}</div>
                                                <div>{customFormatDate(cardData?.createdAt)}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Row>

                                <Card.Title as={'h6'} className="fw-medium">Description Information</Card.Title>
                                <Row>
                                    <div className="col-6">
                                        <Form.Group as={Row} className="mb-1" controlId="infoDescription">
                                            <Form.Label column sm="4" className="label-color">
                                                Description
                                            </Form.Label>
                                            <Col sm="8">
                                                {!isEditDealInfo ?
                                                    <Form.Control as="textarea" rows={2} plaintext readOnly value={cardData?.Description} className="no-focus-border" />
                                                    : <Form.Control
                                                        as="textarea" rows={2}
                                                        value={cardData?.Description}
                                                        name="Description"
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                }
                                            </Col>
                                        </Form.Group>
                                    </div>
                                </Row>
                            </Card>
                            {/* stage history */}
                            <Card body className="p-0 mt-2">
                                <Card.Title as={'h6'} className="fw-medium">Stage History</Card.Title>
                                <div className="tbl-container rounded-table overflow-y-auto" style={{ maxHeight: 'calc(100vh - 21.2vh)' }}>
                                    <div className="table-responsive">
                                        <table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    {stageHistoryTableHeaders.map((data) => (
                                                        <th key={data}>{data}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dealsLog?.data?.length > 0 ? (
                                                    dealsLog.data.map((list) => (
                                                        <tr key={list?._id}>
                                                            <td>{defaultStages.find(stage => stage.id === Number(list?.data?.Stage))?.stageName || ''}</td>
                                                            <td>{list?.data?.Amount && (
                                                                <>
                                                                    {currentCurrencyData?.currency_code} {list?.data?.Amount}
                                                                </>
                                                            )}</td>
                                                            <td>{list?.data?.Probability_}</td>
                                                            <td>{list?.data?.Expected_Revenue && (
                                                                <>
                                                                    {currentCurrencyData?.currency_code} {list?.data?.Expected_Revenue}
                                                                </>
                                                            )}</td>
                                                            <td>{formatDate(list?.data?.Closing_Date)}</td>
                                                            <td>{formatDateTime(list?.updatedAt)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">No records found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Card>
                            {/* open activities */}
                            <Card body className="p-0 mt-2">
                                <Card.Title as={'h6'} className="fw-medium">Open Activities</Card.Title>
                                <OpenActivitiesView activities={dealActivities} />
                            </Card>
                            {/* closed activities */}
                            <Card body className="p-0 mt-2 mb-3">
                                <Card.Title as={'h6'} className="fw-medium">Closed Activities</Card.Title>
                                <ClosedActivitiesView activities={dealActivities} />
                            </Card>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div >
            {sendEmail &&
                <EmailComposer
                    sendEmail={sendEmail}
                    setSendEmail={setSendEmail}
                    id={id}
                    selectedRowData={cardData}
                    moduleName='Deals'
                />
            }
            {permissionDenied && <PermissionDeniedModal />}
            {removeModalData && (<ConfirmationModal data={removeModalData} show={true} handleClose={() => setRemoveModalData(null)} handleSuccess={(subModuleId) => {
                removeData({ subModuleId: removeModalData.subModuleId, payload: { moduleId: removeModalData.payload.moduleId } });
                setRemoveModalData(null);
            }}
            />)}
        </>
    )
}
export default DealDetails